import { COMPACT_MQ, FRAME_HEADER_FILL, FRAME_RADIUS, FRAME_RADIUS_PHONE, PANEL_HEADER, PHONE_MQ } from './constants';
import { forEachTawkIframe, matchesMedia, setImportant, setImportantStyles, viewportBox } from './dom';
import { tawk } from './session';

const FRAME_SHADOW = '0 20px 48px rgba(8, 55, 82, 0.18), 0 8px 20px rgba(8, 55, 82, 0.1)';

let layoutRaf = 0;
let layoutPulseTimer = 0;

function chatFrameMetrics() {
  const phone = matchesMedia(PHONE_MQ);
  const compact = matchesMedia(COMPACT_MQ);
  const { width: vw, height: vh, offsetTop, offsetLeft } = viewportBox();
  const inset = phone ? 8 : 16;
  const width = phone
    ? Math.max(280, Math.round(vw - inset * 2))
    : compact
      ? Math.min(420, Math.max(320, Math.round(vw - inset * 2)))
      : 360;
  const height = phone
    ? Math.max(300, Math.round(vh - inset * 2))
    : compact
      ? Math.min(640, Math.max(360, Math.round(vh - inset * 2)))
      : Math.min(560, Math.max(440, Math.round(vh - 48)));
  const left = phone
    ? Math.round(offsetLeft + inset)
    : Math.round(offsetLeft + Math.max(inset, vw - width - inset));
  const top = phone
    ? Math.round(offsetTop + inset)
    : Math.round(offsetTop + Math.max(inset, vh - height - inset));
  return { width, height, left, top, radius: phone ? FRAME_RADIUS_PHONE : FRAME_RADIUS };
}

function unhideTawkContainer(iframe) {
  let el = iframe.parentElement;
  for (let i = 0; i < 6 && el && el !== document.body; i += 1) {
    try {
      const cs = getComputedStyle(el);
      if (cs.display === 'none') el.style.removeProperty('display');
      if (cs.visibility === 'hidden') el.style.removeProperty('visibility');
      if (cs.opacity === '0') el.style.removeProperty('opacity');
    } catch {
      // Cross-origin or detached node — safe to ignore.
    }
    el = el.parentElement;
  }
}

function applyTawkChatFrame(iframe) {
  if (!iframe || !tawk.wantVisible) return;
  const { width, height, left, top, radius } = chatFrameMetrics();
  const px = (n) => `${n}px`;
  setImportantStyles(iframe, {
    position: 'fixed',
    width: px(width),
    height: px(height),
    'min-width': px(width),
    'min-height': px(height),
    'max-width': px(width),
    'max-height': px(height),
    left: px(left),
    top: px(top),
    right: 'auto',
    bottom: 'auto',
    inset: `${top}px auto auto ${left}px`,
    'border-radius': radius,
    overflow: 'hidden',
    'background-color': '#ffffff',
    background: `linear-gradient(to bottom, ${PANEL_HEADER} ${FRAME_HEADER_FILL}, #ffffff ${FRAME_HEADER_FILL})`,
    'box-shadow': FRAME_SHADOW,
    border: '0',
    outline: 'none',
  });
  let wrap = iframe.parentElement;
  for (let i = 0; i < 4 && wrap && wrap !== document.body; i += 1) {
    setImportant(wrap, 'background', 'transparent');
    setImportant(wrap, 'background-color', 'transparent');
    wrap = wrap.parentElement;
  }
  iframe.dataset.tawkMobileLayout = '1';
}

export function layoutTawkIframes() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('tawk-chat-open', tawk.wantVisible);
  forEachTawkIframe((iframe) => {
    if (!tawk.wantVisible) {
      setImportant(iframe, 'pointer-events', 'none');
      setImportant(iframe, 'visibility', 'hidden');
      setImportant(iframe, 'opacity', '0');
      return;
    }
    iframe.style.removeProperty('visibility');
    iframe.style.removeProperty('opacity');
    iframe.style.removeProperty('pointer-events');
    unhideTawkContainer(iframe);
    applyTawkChatFrame(iframe);
  });
}

export function scheduleTawkLayout() {
  if (typeof window === 'undefined' || layoutRaf) return;
  layoutRaf = window.requestAnimationFrame(() => {
    layoutRaf = 0;
    layoutTawkIframes();
  });
}

export function pulseTawkLayout(attempts = 12) {
  scheduleTawkLayout();
  if (typeof window === 'undefined' || attempts <= 1 || !tawk.wantVisible) return;
  window.clearTimeout(layoutPulseTimer);
  layoutPulseTimer = window.setTimeout(() => pulseTawkLayout(attempts - 1), 90);
}

export function cancelTawkLayout() {
  if (typeof window === 'undefined') return;
  if (layoutRaf) {
    window.cancelAnimationFrame(layoutRaf);
    layoutRaf = 0;
  }
  window.clearTimeout(layoutPulseTimer);
  layoutPulseTimer = 0;
}
